<script lang="ts">
import { defineComponent } from 'vue'
import OptoutMain from './Main.vue'
import OptoutBreadcrumb from './Breadcrumb.vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'

export default defineComponent({
  name: 'OptoutApp',

  components: {
    OptoutMain,
    OptoutBreadcrumb,
    PageHeadingDefault,
  },
})
</script>

<template>
  <TemplateDefault :has-timeline="false">
    <template #pageHeading>
      <PageHeadingDefault>
        行動ターゲティング広告について
      </PageHeadingDefault>
    </template>

    <template #main>
      <OptoutMain />
    </template>

    <template #breadcrumbFooter>
      <OptoutBreadcrumb />
    </template>
  </TemplateDefault>
</template>
